import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CameraOutline, FolderOutline } from 'antd-mobile-icons';

const projects = [
  {
    id: 'photo-fixation',
    title: 'Фотофиксация',
    description: 'Фотоотчёт по объектам из реестра АИП',
    icon: CameraOutline,
    color: '#1890ff',
    bg: '#e6f4ff',
  },
  {
    id: 'other',
    title: 'Другие проекты',
    description: 'Дополнительные спецпроекты будут добавлены позже',
    icon: FolderOutline,
    color: '#8c8c8c',
    bg: '#f5f5f5',
    disabled: true,
  },
];

function SpecialProjectsPage() {
  const navigate = useNavigate();

  return (
    <div>
      <h2 style={{ margin: '12px 0', fontSize: 20, fontWeight: 600 }}>Спецпроекты</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {projects.map((project) => {
          const Icon = project.icon;
          return (
            <div
              key={project.id}
              onClick={() => !project.disabled && navigate(project.path || `/special-projects/${project.id}`)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: 16,
                borderRadius: 16,
                background: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0',
                opacity: project.disabled ? 0.6 : 1,
                cursor: project.disabled ? 'not-allowed' : 'pointer',
                transition: 'transform 0.15s, box-shadow 0.15s',
              }}
              onMouseDown={(e) => {
                if (!project.disabled) {
                  e.currentTarget.style.transform = 'scale(0.98)';
                }
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  background: project.bg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: project.color,
                  fontSize: 28,
                  flexShrink: 0,
                }}
              >
                <Icon />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    color: '#262626',
                    marginBottom: 4,
                  }}
                >
                  {project.title}
                </div>
                <div style={{ fontSize: 13, color: '#8c8c8c', lineHeight: 1.4 }}>
                  {project.description}
                </div>
              </div>
              {!project.disabled && (
                <span style={{ color: '#bfbfbf', fontSize: 18 }}>›</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SpecialProjectsPage;
